import { Flex } from 'antd';
import React from 'react';
import NoConversationImg from '~/assets/jumelles.png';
import Dialogue from '~/components/shared/Dialogue/Dialogue';
import { SEARCH_PARAMETERS_API_IDS } from '~/helpers/conversation';
import { useConversations } from '~/hooks/useConversations';

import CreateConversationModal from '../ConversationSearch/CreateConversationModal/CreateConversationModal';
import ConversationView from './ConversationView';

function ConversationPanel({ selectedConversation, setSelectedConversation, params, activeMerchantId, onStatusChange }) {
  const { data } = useConversations(activeMerchantId, params);
  const orderIdSearch = params[SEARCH_PARAMETERS_API_IDS.ORDER_ID];
  const noDataWithSearchParam = data && data.length === 0 && orderIdSearch;

  if (selectedConversation) {
    return (
      <Flex className='w-full h-full bg-white rounded-sm'>
        <ConversationView
          key={selectedConversation}
          conversationId={selectedConversation}
          activeMerchantId={activeMerchantId}
          onStatusChange={onStatusChange}
        />
      </Flex>
    );
  }

  if (noDataWithSearchParam) {
    return (
      <Flex className='w-full h-full bg-white rounded-sm' justify='center' align='center' vertical gap={24}>
        <img src={NoConversationImg} alt='' width={90} />
        <Dialogue type='info' light message="Il n'y a pas de conversation existante avec ce numéro de commande à l'horizon..." />
        <CreateConversationModal
          setSelectedConversation={setSelectedConversation}
          baseOrderIdNumber={orderIdSearch}
          customText="Nouveau message à partir d'un n° de commande"
        />
      </Flex>
    );
  }

  return (
    <Flex className='w-full h-full bg-white rounded-sm' justify='center' align='center' vertical gap={16}>
      <p className='body1 text-grey-medium text-center'>
        Sélectionnez ou démarrez une conversation
        <br />
        avec vos clients et clientes
      </p>
      <CreateConversationModal setSelectedConversation={setSelectedConversation} customText='Démarrer une conversation' />
    </Flex>
  );
}

export default ConversationPanel;
